import PhaseUsageReport from './PhaseUsageReport';
import UserInfluenceReport from './UserInfluenceReport';
import UserHashtagReport from './UserHashtagReport';
import UserRelationReport from './UserRelationReport';
import TopHashtagsReport from './TopHashtagsReport';
import HashtagAnalysisReport from './HashtagAnalysisReport';
import HashtagEngagementReport from './HashtagEngagementReport';
import AccountByFollowersReport from './AccountByFollowersReport';
import TopInfluencersReport from './TopInfluencersReport';

export default{
	UserInfluenceReport:UserInfluenceReport,
	UserHashtagReport:UserHashtagReport,
	UserRelationReport:UserRelationReport,
	TopHashtagsReport:TopHashtagsReport,
	HashtagAnalysisReport:HashtagAnalysisReport,
	HashtagEngagementReport:HashtagEngagementReport,
	PhaseUsageReport:PhaseUsageReport,
	AccountByFollowersReport:AccountByFollowersReport,
	TopInfluencersReport:TopInfluencersReport
}